import { RoutesResRoutes } from '@conf';

/**
 * basic-page-layout l-containerのcolorを変更するURL
 */
export const CHANGE_CONTAINER_COLOR_URLS = [`/${RoutesResRoutes.SEATMAP}`] as string[];
